import axios from 'axios';
import React, { useState, useMemo, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import { Label } from 'reactstrap'
import { environment } from '../../../env';
import { successModalToggle, getVillagesAction, loaderAction, getSoldGalaAction, getBuildingAction } from '../../../redux/actions/Index';
import ErrorComponents from '../../errorComponents/ErrorComponents';
import AsyncSelect from 'react-select/async';
import { PencilLine } from '@phosphor-icons/react';
import { toast } from 'react-toastify';

function EditSoldGala({ title, data, galaSoldHandeler }, ...props) {
    const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);
    const galaList = useSelector((state) => state?.ModalReducer?.galaList);
    const [GalaFil, setGalaFil] = useState([]);
    const [modal, setModal] = useState(false);
    const [filterBuilding, setFilterBuilding] = useState([]);
    const [investordata, setInvestorData] = useState([]);
    const [btndis, setBtndis] = useState(false)
    const [editt, setEdit] = useState(false)
    const [ID, setID] = useState(0)
    const toggle = () => { setModal(!modal); setEdit(!editt) }
    const dispatch = useDispatch()
    const {
        register,
        handleSubmit,
        watch,
        control,
        reset,
        formState: { errors },
    } = useForm();
    var selectedBuildingId = watch("building");
    var selectedGala = watch("gala");

    const onSubmit = async (data) => {
        setBtndis(true);
        dispatch(loaderAction(true))
        try {
            await axios.put(`${environment.baseUrl}editsold-gala/${ID}`, data).then((form) => {
                if (form.data.code === 200) {
                    dispatch(successModalToggle());
                    getBuildingData()
                    galaSoldHandeler()
                    dispatch(loaderAction(false))
                    setBtndis(false);
                    toggle();
                    reset();
                } else {
                    toast.error(form.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    setBtndis(false);
                }
            })
        }
        catch (err) {
            setBtndis(false);
            dispatch(loaderAction(false))
            console.log(err);
        }
    };

    const CancelButton = () => {
        toggle();
        reset();
        setBtndis(false);
    }

    const getSoldGalaData = () => {
        try {
            axios.get(`${environment.baseUrl}sold-gala/`).then(res => {
                dispatch(getSoldGalaAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const FilterBuildingGala = () => {
        var galaselectedd = galaList?.filter((galalist) => galalist.building.id == selectedBuildingId);
        setGalaFil(galaselectedd);
    }

    const getBuildingData = () => {
        try {
            axios.get(`${environment.baseUrl}building/`).then(res => {
                dispatch(getBuildingAction(res.data));

            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getInvestorData = () => {
        axios.get(`${environment.baseUrl}investor/`).then(res => {
            let arr = []
            res.data.map(curElm => {
                arr.push({ label: curElm.name, value: curElm.id })
            })
            arr?.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))
            setInvestorData(arr)
        })
            .catch(res => {
                console.log("error");
            })
    }

    const InvestorOptions = async (query) => {
        let dd;
        const filteredInvestorURL = `${environment.baseUrl}filter-investor/`;
        const FilterInvestorPayload = new FormData();
        FilterInvestorPayload.append('query', query);
        FilterInvestorPayload.append('building', selectedBuildingId);
        FilterInvestorPayload.append('gala', selectedGala);
        let filteredInvesters = [];
        const result = await axios.post(filteredInvestorURL, FilterInvestorPayload).then((response) => {
            console.log(userProject);
            let filterData = []
            response.data.map(item => {
                if (item.building.project == userProject) {
                    filterData.push(item);
                }
            })
            filterData.map((invesrtorList) => {
                filteredInvesters.push({ label: invesrtorList.name, value: invesrtorList.id })
            })
        })

        if (filteredInvesters.length > 0) {
            return filteredInvesters
        } else {
            return []
        }
    };

    useMemo(() => {
        reset({
            'Investors': data.Investors.id,
            'building': data.building.id,
            'gala': data.gala.id,
            'sold_gala_area': data.sold_gala_area,
            'sub_gala_name': data.sub_gala_name,
            'index': data.index,
            'created_at':data.created_at
        })
        setID(data.id)
        if (userProject) {
            var projectBuilding = buildingList?.filter(
                (filterBuilding) => filterBuilding.project.id == userProject
            );
            projectBuilding?.sort((a, b) => (a.building_no > b.building_no) ? 1 : ((b.building_no > a.building_no) ? -1 : 0))
            setFilterBuilding(projectBuilding);
        }

        if (selectedBuildingId) {
            FilterBuildingGala()
        }
    }, [editt])

    return (
        <>
            <button
                onClick={() => { toggle(); getInvestorData() }}
                className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' /></button>
            <Modal className='border-0' isOpen={modal} toggle={props.toggle} size="lg" centered>
                <ModalHeader className='bg-base-color ' ><span className='title-font-700 fs-36 text-base-white'>Edit Sold Gala</span></ModalHeader>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <ModalBody className='bg-background-color px-5'>
                        <div className="row">
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Select Investor *
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <Controller
                                        className="p-3 mb-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        control={control}
                                        name="Investors"
                                        render={({
                                            field: { onChange },
                                            fieldState: { isTouched, isDirty, error },
                                            formState,
                                        }) => (
                                            <AsyncSelect defaultValue={{ label: data.Investors.name, value: data.Investors.id }} placeholder="Investor" cacheOptions defaultOptions={investordata} loadOptions={InvestorOptions} onChange={onChange} className='w-100' />
                                        )}
                                    />
                                </div>
                                {errors.Investors && (
                                    <ErrorComponents error={"Investors is required *"} />
                                )}
                                <br />
                            </div>
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Building no *
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <select
                                        id="building"
                                        name="building"
                                        className="p-4 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        {...register("building", { required: true })}
                                    >
                                        <option value="">Building Number</option>
                                        {filterBuilding?.map((data, i) => {
                                            return (
                                                <option value={data.id} key={i}>{data.building_no}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                                {
                                    errors.building && (
                                        <ErrorComponents error={"Building no is required *"} />
                                    )
                                }
                                <br />
                            </div>
                            <div className='col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1'>
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Gala No *
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <select
                                        id="gala"
                                        name="gala"
                                        className="p-4 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                        {...register("gala", { required: true })}
                                    >
                                        <option value="">Gala No</option>
                                        {GalaFil?.map((data, i) => {
                                            return (
                                                <option value={data?.id} key={i}>{data?.gala_no}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                                {errors.gala && <ErrorComponents error={'Gala No is required *'} />}
                                <br />
                            </div>
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Sub Gala
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <div className=" w-100">
                                        <input
                                            className="p-4 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                            type="text"

                                            placeholder="Sub Gala"
                                            {...register("sub_gala_name", { required: true })}
                                        />
                                    </div>
                                </div>
                                {errors.sub_gala_name && (
                                    <ErrorComponents
                                        error={"Sub Gala is required *"}
                                    />
                                )}
                                <br />
                            </div>
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Sold Area
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <div className="numberTextSuffix w-100">
                                        <input
                                            className="p-4 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                            type="text"
                                            placeholder="Sold Area"
                                            {...register("sold_gala_area", { required: true })}
                                        />
                                    </div>
                                </div>
                                {errors.sold_gala_area && (
                                    <ErrorComponents
                                        error={"Sold Gala Area is required *"}
                                    />
                                )}
                                <br />
                            </div>
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Index No
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <div className="w-100">
                                        <input
                                            className="p-4 border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                            type="text"
                                            placeholder="Index Number"
                                            {...register("index",)}
                                        />
                                    </div>
                                </div>
                                {errors.index && (<ErrorComponents error={"Index number is required *"} />)}
                                <br />
                            </div>
                            <div className={`${userProject !== undefined ? "col-12 pb-3 pt-1" : "col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1"}`}>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    Selling date
                                </Label>
                                <br />

                                <div className='mt-1  d-flex gap-3'>
                                    <input
                                        className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        type='date'
                                        {...register("created_at",
                                            {
                                                required: true
                                                ,
                                            })}
                                    />
                                </div>
                                {errors.created_at && <ErrorComponents error={'Selling date is required *'} />}
                                <br />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Cancel</span></Button>{' '}
                        <Button className='border-radius-7 p-3 d-flex align-items-center buttons' disabled={btndis}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Submit</span></Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </>
    )
};


export default EditSoldGala